// extracted by mini-css-extract-plugin
module.exports =  {"more-button":"_93444fe79c--more-button--plYc5"};